import React from 'react';
import { useTools } from '../../../../ToolProvider.jsx';
import { IconUndoHistory, IconRedoHistory } from '../../../ToolSelectorTop/Icons.jsx';

const HistoryPanel = () => {
    const { onUndo, onRedo, jumpToSnapshot, historyInfo } = useTools();
    const { entries, currentIndex } = historyInfo;

    return (
        <div className="flex flex-col h-full w-full gap-3">

            {/* Botones undo / redo */}
            <div className="flex gap-2 px-3 pt-2">
                <button
                    onClick={onUndo}
                    disabled={currentIndex <= 0}
                    className="btn btn-sm flex-1 gap-1 disabled:opacity-40"
                    title="Deshacer"
                >
                    <IconUndoHistory />
                    Deshacer
                </button>
                <button
                    onClick={onRedo}
                    disabled={currentIndex >= entries.length - 1}
                    className="btn btn-sm flex-1 gap-1 disabled:opacity-40"
                    title="Rehacer"
                >
                    Rehacer
                    <IconRedoHistory />
                </button>
            </div>

            <div className="divider my-0 px-3" />

            {/* Lista de entradas — más reciente arriba */}
            <div className="flex flex-col gap-1 overflow-y-auto px-3 pb-4">
                {entries.length === 0 && (
                    <p className="text-sm opacity-40 text-center mt-6">
                        Sin historial todavía
                    </p>
                )}
                {[...entries].reverse().map((label, reversedIndex) => {
                    const index = entries.length - 1 - reversedIndex;
                    const isCurrent = index === currentIndex;
                    const isFuture = index > currentIndex;

                    return (
                        <button
                            key={index}
                            onClick={() => jumpToSnapshot(index)}
                            className={`
                                w-full text-left px-3 py-2 rounded-md text-sm transition-colors
                                ${isCurrent
                                    ? 'bg-primary text-primary-content font-semibold'
                                    : isFuture
                                        ? 'opacity-40 hover:opacity-70 hover:bg-base-200'
                                        : 'hover:bg-base-200'
                                }
                            `}
                        >
                            <span className="mr-2 opacity-50 text-xs">#{index + 1}</span>
                            {label}
                            {isCurrent && <span className="ml-2 text-xs opacity-70">(actual)</span>}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default HistoryPanel;
